import { render, staticRenderFns } from "./AboutExp.vue?vue&type=template&id=3859cb8a&scoped=true"
import script from "./AboutExp.vue?vue&type=script&lang=js"
export * from "./AboutExp.vue?vue&type=script&lang=js"
import style0 from "./AboutExp.vue?vue&type=style&index=0&id=3859cb8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3859cb8a",
  null
  
)

export default component.exports